import { useEsriMapStore } from '../map-window/hooks/use-esri-map-store';
import { getFullLocationAddressForDisplay } from '../location/helpers';
import { useUnitAssignment } from '../unit-assignment/unit-assignment-context';
import { SelfAssignmentEvents } from './unit-self-assignment-modal';
import { getEventDataForSelfAssignmentModal } from '../fr-event-common-components/helpers';

export const useMapStoreDataForSelfAssignmentModal = (): SelfAssignmentEvents => {
    const mapStore = useEsriMapStore();
    const unitAssignment = useUnitAssignment();

    const { selectedMapLedgerEvent } = mapStore;
    if (!selectedMapLedgerEvent) return {};

    const assignedEventId = unitAssignment?.assignedEvent?.eventId;
    const assignedEvent = assignedEventId ? mapStore.getMapLedgerEvent(assignedEventId) : null;

    const selectedEvent = getEventDataForSelfAssignmentModal({
        eventId: selectedMapLedgerEvent.entityId,
        eventNumber: selectedMapLedgerEvent.agencyEventNumber,
        eventLocation: getFullLocationAddressForDisplay(selectedMapLedgerEvent),
        assignedUnits: selectedMapLedgerEvent.assignedUnits,
    });

    return assignedEvent
        ? {
              selectedEvent,
              assignedEvent: getEventDataForSelfAssignmentModal({
                  eventId: assignedEvent.entityId,
                  eventNumber: assignedEvent?.agencyEventNumber,
                  eventLocation: assignedEvent && getFullLocationAddressForDisplay(assignedEvent),
                  assignedUnits: assignedEvent.assignedUnits,
              }),
          }
        : { selectedEvent };
};
